import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumb from 'component/Breadcrumb'

const RuptureHeader = (props) => {
  const { translate, currentTitle } = props

  const renderBreadcrumb = () => {
    const steps = [
      { link: '/', title: translate('mobile.home') },
      { link: '/rupture', title: translate('ruptures.title') },
      { title: currentTitle },
    ]

    return <Breadcrumb steps={steps} />
  }

  return renderBreadcrumb()
}

RuptureHeader.propTypes = {
  translate: PropTypes.func.isRequired,
  currentTitle: PropTypes.string,
}

export default RuptureHeader
